module.exports = __webpack_public_path__ + "static/img/07.072beb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/07.jpg
// module id = BlNa
// module chunks = 0